import {
  ref, computed, reactive, watch, toRef,
} from '@vue/composition-api'
import reFetchAPI from '@/utils/refetch-api'
import { errorNotification } from '@/utils/toast-notifications'

export default function useUsersList(ctx) {
  const tableColumns = [
    { key: 'user' },
    { key: 'phoneNumber', label: 'Phone Number' },
    { key: 'email', label: 'Email' },
    { key: 'gender', label: 'Gender' },
    { key: 'activeState', label: 'Status' },
  ]
  const statusOptions = [
    {
      label: 'Approved',
      value: 'ACTIVE',
    },
    {
      label: 'Blocked',
      value: 'INACTIVE',
    },
  ]
  const queryParams = reactive({
    perPage: 10,
    page: 1,
    text: null,
    device_id: null,
    activeState: null,
    external_id: null,
  })
  const canSearch = computed(() => queryParams.device_id || queryParams.text || queryParams.activeState || queryParams.external_id)
  const usersLoading = ref(false)
  const users = computed(() => ctx.root.$store.getters['users/getUsers'])
  const totalUsers = computed(() => ctx.root.$store.getters['users/getTotalUsers'])
  const fetchUsers = async () => {
    if (usersLoading.value) return
    try {
      usersLoading.value = true
      await ctx.root.$store.dispatch('users/fetchUsers', queryParams)
    } catch (error) {
      if (error.message.includes('timeout')) {
        fetchUsers()
      } else {
        reFetchAPI(fetchUsers)
        errorNotification('Something went wrong!!, retrying..')
      }
    } finally {
      usersLoading.value = false
    }
  }

  watch([toRef(queryParams, 'page'), toRef(queryParams, 'perPage')], () => {
    fetchUsers()
  })
  // watch(() => queryParams.activeState, () => {
  //   fetchUsers()
  //   queryParams.page = 1
  // })

  // fetchUsers()
  return {
    tableColumns,
    canSearch,
    statusOptions,
    usersLoading,
    totalUsers,
    users,
    queryParams,
    fetchUsers,
  }
}
